import { useNavigate } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from '@/components/ui/dropdown-menu';
import { ROUTES } from '@/config/routes';

interface NewPropertySplitButtonProps {
  onOpenDrawer: () => void;
  /** Gates the "Add via integration" item, matching how the integration
   *  entry point is gated everywhere else on this page. */
  canIntegrate: boolean;
}

export function NewPropertySplitButton({
  onOpenDrawer,
  canIntegrate,
}: NewPropertySplitButtonProps) {
  const navigate = useNavigate();

  return (
    <div className="inline-flex">
      <Button
        type="button"
        onClick={onOpenDrawer}
        className="rounded-r-none px-6"
      >
        Add Property
      </Button>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            type="button"
            aria-label="More Property Options"
            className="rounded-l-none border-l border-l-primary-foreground/20 px-2 max-lg:min-w-11"
          >
            <ChevronDown className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onSelect={onOpenDrawer}>
            Add an individual property
          </DropdownMenuItem>
          <DropdownMenuItem
            onSelect={() => navigate(ROUTES.PROPERTIES_NEW_IMPORT)}
          >
            Add properties in bulk
          </DropdownMenuItem>
          {canIntegrate && (
            <DropdownMenuItem onSelect={() => navigate(ROUTES.INTEGRATIONS)}>
              Add via integration
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
